import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';

import { KeyValue } from '@angular/common';
import { DetailInfoTypeComponent } from '../detail-info-type.component';

@Component({
    selector: 'detail-info-multi-select',
    templateUrl: './detail-info-multi-select.component.html',
    standalone: false
})
export class DetailInfoMultiSelectComponent extends DetailInfoTypeComponent implements OnInit {

  public optionsObs: Observable<KeyValue<string, string>[]> = of([]);

  ngOnInit() {
    super.ngOnInit();
    // Deferred, exactly as DetailInfoSelectComponent does: for a STATIC field the base ngOnInit
    // queues a microtask that sets optionsObs to its `options` input, which is empty here. Assigning
    // synchronously meant the base's microtask then overwrote the real options with [] and every
    // static multi-select dropdown rendered "No items found". Queuing after super's microtask makes
    // this assignment the last one. Rule-driven (DynamicMulti) fields are unaffected either way -
    // the base swaps in the rule's options when ExecuteRule returns.
    Promise.resolve().then(() => {
      this.optionsObs = of([...(this.detailInfo?.inputContentDatas ?? [])]);
    });
  }
}
